import { useTranslation } from "react-i18next";
import { TicketHistory } from "../../../api/support";
import { ACTION_LABEL_KEYS, ACTION_ICONS, formatDate } from "./ticket-constants";

interface HistoryTabProps {
    ticketHistory: TicketHistory[];
}

export function HistoryTab({ ticketHistory }: HistoryTabProps) {
    const { t } = useTranslation();
    return (
        <div className="h-full overflow-auto p-4">
            {ticketHistory.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-12 ticket-history-empty">
                    <svg className="w-10 h-10 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="text-sm font-medium">{t("noHistory")}</p>
                    <p className="text-xs mt-1">{t("noHistoryDesc")}</p>
                </div>
            ) : (
                <div className="space-y-0">
                    {ticketHistory.map((h, idx) => (
                        <div key={h.ref} className="flex gap-3 relative">
                            {idx < ticketHistory.length - 1 && (
                                <div className="absolute left-[13px] top-8 bottom-0 w-px ticket-history-line" />
                            )}
                            <div className="w-7 h-7 rounded-full flex items-center justify-center shrink-0 z-10 ticket-history-icon">
                                {ACTION_ICONS[h.action] ?? (
                                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                )}
                            </div>
                            <div className="pb-5 min-w-0 flex-1">
                                <p className="text-xs font-semibold ticket-history-action">{ACTION_LABEL_KEYS[h.action] ? t(ACTION_LABEL_KEYS[h.action]) : h.action}</p>
                                <div className="flex items-center gap-1.5 mt-1">
                                    <span className="text-xs bg-red-50 text-red-500 line-through px-1.5 py-0.5 rounded">{h.old_value}</span>
                                    <svg className="w-3 h-3 shrink-0" style={{ color: 'var(--subtitle-text-color)' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                    </svg>
                                    <span className="text-xs bg-green-50 text-green-600 px-1.5 py-0.5 rounded font-medium">{h.new_value}</span>
                                </div>
                                <p className="text-[11px] mt-1.5 flex items-center gap-1 ticket-history-meta">
                                    <span className="font-medium">{h.performed_by_name}</span>
                                    <span>·</span>
                                    <span>{formatDate(h.created_at)}</span>
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
